export default __webpack_public_path__ + "static/media/locked.09d77289.svg";